/**
*  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, OnInit } from '@angular/core';
import { KnowledgeBaseDetailService } from './knowledgebasedetail.service';
import { KnowledgeBaseDetailInfo } from './knowledgebasedetailinfo';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { KbaAttachment } from '../../model/kbaattachmentresponse';
import { HttpRequest, HttpEvent, HttpEventType, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonConstants } from './../../../../../common/constants/common-constants';
import * as FileSaver from 'file-saver';
import { RateInfoResponse } from '../../model/rateresponse';
import { CustomerPreferenceService } from './../../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from './../../../../preference/customerpreference.model';
declare var $: any;

@Component({
    selector: 'zsd-knowledgebasedetail',
    templateUrl: './knowledgebasedetail.component.html',
    styleUrls: ['./knowledgebasedetail.component.scss']
})
export class KnowledgeBaseDetailComponent implements OnInit {
    readonly ARTICLE_INDEX = 1000;
    readonly FAQ_INDEX = 2000;
    readonly WORKAROUND_INDEX = 3000;
    readonly SOLUTION_INDEX = 4000;

    kbaId: number;
    knowledgebaseDetail: KnowledgeBaseDetailInfo = new KnowledgeBaseDetailInfo();
    isArticle: boolean;
    isFAQ: boolean;
    isSolution: boolean;
    isWorkaround: boolean;
    isItemTypes: boolean;
    isItems: boolean;
    fromRequestDetailPage = false;
    requestId: number;
    attachmentIsLoading = false;
    attachmentSpinnerStart = true;


    kbaAttachmentResponse: any;
    hasAttachment: boolean;
    kbaCommentEnabledForCustomer: boolean;
    constructor(private knowledgebasedetailservice: KnowledgeBaseDetailService,
        private http: HttpClient, private route: ActivatedRoute, public router: Router,
        private customerPreferenceService: CustomerPreferenceService) {
        this.getCustomerPreferences();
        this.knowledgebaseDetail = new KnowledgeBaseDetailInfo();
        this.router.events.subscribe(
            () => {
                if (this.router.url.includes('/requests')) {
                    this.fromRequestDetailPage = true;
                }
            });
    }

    getCustomerPreferences() {
        this.customerPreferenceService.getPreferenceList().subscribe(
            (preferences: CustomerPreferenceResponse) => {
              this.kbaCommentEnabledForCustomer = preferences.kbaCommentEnabledForCustomer;
             },
            err => console.error(err)
          );
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.kbaId = params['id'];
            this.requestId = params['requestId'];
        });
        if (this.fromRequestDetailPage) {
            this.getSolutionDetails();
        } else {
            this.getKnowledgebaseDetail();
        }
    }

    getKnowledgebaseDetail(): void {
        let knowledgebaseDetailService = this.knowledgebasedetailservice;
        this.knowledgebasedetailservice.getKnowledgeBaseDetail(this.kbaId).subscribe(
            (knowledgebaseDetail: KnowledgeBaseDetailInfo) => {
                this.knowledgebaseDetail = knowledgebaseDetail;
                switch (knowledgebaseDetail.kbaBasicInfo.kbaTypeIndex) {
                    case this.ARTICLE_INDEX:
                        this.isArticle = true;
                        break;
                    case this.FAQ_INDEX:
                        this.isFAQ = true;
                        break;
                    case this.SOLUTION_INDEX:
                        this.isSolution = true;
                        break;
                    case this.WORKAROUND_INDEX:
                        this.isWorkaround = true;
                        break;
                }
                if (knowledgebaseDetail.item && knowledgebaseDetail.item.length > 0) {
                    this.isItems = true;
                }
                if (knowledgebaseDetail.itemType && knowledgebaseDetail.itemType.length > 0) {
                    this.isItemTypes = true;
                }

                $(function () {
                    $('#rateAvg').rateYo({
                        starWidth: '16px',
                        rating: knowledgebaseDetail.kbaBasicInfo.averageRating,
                        ratedFill: '#15DB66',
                        normalFill: '#D4D6DA',
                        readOnly: true
                    });
                });
                $(function () {
                    $('#rateUser').rateYo({
                        starWidth: '16px',
                        rating: knowledgebaseDetail.rating,
                        ratedFill: '#15DB66',
                        normalFill: '#D4D6DA',
                        fullStar: true,
                        onSet: (rating, rateYoInstance) => {
                            rateYoInstance = rateYoInstance;
                            knowledgebaseDetailService.rateKba(knowledgebaseDetail.kbaBasicInfo.kbaId, rating).subscribe(
                                (rateInfoResponse: RateInfoResponse) => {
                                    // update averate ratig and vote count after user rates any knowledgebase
                                    $('#rateAvg').rateYo('option', 'rating', rateInfoResponse.updatedAvgRating);
                                    knowledgebaseDetail.voteCount = rateInfoResponse.updatedVoteCount;
                                }
                            );
                        }
                    });
                });
            },
            (err: HttpErrorResponse) => {
                console.error(err);
                if (err.status === 400 && err.error.code === 'kba_view_error') {
                    // Redirect to list page if wrong kba id is provided in the url.
                    this.router.navigateByUrl('/selfhelp');
                }
            }
        );

    }
    getAttachment() {
        this.attachmentIsLoading = true;
        if (this.fromRequestDetailPage) {
            this.knowledgebasedetailservice.getSolutionAttachmentDetails(this.requestId).subscribe((kbaAttachment: any) => {
                this.kbaAttachmentResponse = kbaAttachment;
                this.attachmentIsLoading = false;
                this.attachmentSpinnerStart = false;
            });
        } else {
            this.knowledgebasedetailservice.getAttachmentDetails(this.kbaId).subscribe((kbaAttachment: any) => {
                this.kbaAttachmentResponse = kbaAttachment;
                this.attachmentIsLoading = false;
                this.attachmentSpinnerStart = false;
            });
        }
    }

    attachmentDetails(kbaAttachment: KbaAttachment) {
        this.attachmentIsLoading = true;
        let attachmentParentType = 'KbaAttachment';
        this.downloadAttachment(kbaAttachment.attachmentId, attachmentParentType, this.knowledgebaseDetail.kbaBasicInfo.kbaId);
    }

    downloadAttachment(attachmentId: number, attachmentParentType: String, parentEntityId: number) {
        const downloadRequest = new HttpRequest('GET', CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/download/' + attachmentId +
            '?attachmentParentType=' + attachmentParentType + '&parentEntityId=' + parentEntityId, {
                responseType: 'blob'
            });
        this.http.request(downloadRequest).subscribe(
            (event: HttpEvent<any>) => {
                if (event) {
                    switch (event.type) {
                        case HttpEventType.ResponseHeader:
                            let contentDispositionHeader = event.headers.get('Content-Disposition');
                            contentDispositionHeader = contentDispositionHeader.substr(22, (contentDispositionHeader.length - 1));
                            console.log(contentDispositionHeader); // Always null here although I expected it to be there.
                            break;

                        case HttpEventType.Response:
                            let contentDispositionHeader2 = event.headers.get('Content-Disposition');
                            contentDispositionHeader2 = contentDispositionHeader2.substr(22, (contentDispositionHeader2.length - 23));
                            const downloadedFile: Blob = event.body;
                            this.attachmentIsLoading = false;
                            FileSaver.saveAs(downloadedFile, contentDispositionHeader2);
                            break;
                    }
                }
            },
            err => console.log(err.error)
        );
    }

    getSolutionDetails(): void {
        let solutionDetailService = this.knowledgebasedetailservice;
        let requestNumber = this.requestId;
        this.knowledgebasedetailservice.getSolutionDetailforRequests(this.requestId).subscribe(
            (solutionDetail: KnowledgeBaseDetailInfo) => {
                this.knowledgebaseDetail = solutionDetail;
                this.kbaId = solutionDetail.kbaBasicInfo.kbaId;
                this.isSolution = true;
                if (solutionDetail.item && solutionDetail.item.length > 0) {
                    this.isItems = true;
                }
                if (solutionDetail.itemType && solutionDetail.itemType.length > 0) {
                    this.isItemTypes = true;
                }

                $(function () {
                    $('#rateAvg').rateYo({
                        starWidth: '16px',
                        rating: solutionDetail.kbaBasicInfo.averageRating,
                        ratedFill: '#15DB66',
                        normalFill: '#D4D6DA',
                        readOnly: true
                    });
                });
                $(function () {
                    $('#rateUser').rateYo({
                        starWidth: '16px',
                        rating: solutionDetail.rating,
                        ratedFill: '#15DB66',
                        normalFill: '#D4D6DA',
                        fullStar: true,
                        onSet: (rating, rateYoInstance) => {
                            rateYoInstance = rateYoInstance;
                            solutionDetailService.solutionDetailrateKba(requestNumber, rating).subscribe(
                                (rateInfoResponse: RateInfoResponse) => {
                                    // update averate ratig and vote count after user rates any knowledgebase
                                    $('#rateAvg').rateYo('option', 'rating', rateInfoResponse.updatedAvgRating);
                                    solutionDetail.voteCount = rateInfoResponse.updatedVoteCount;
                                }
                            );
                        }
                    });
                });
            },
            err => {
                console.error(err);
            }
        );

    }
    showRequestPage() {
        let search = 'id:' + this.requestId;
        let searchTerm = JSON.stringify(search);
        let navigationExtras: NavigationExtras = {
            queryParams: {
                'searchTerm': searchTerm
            },
            queryParamsHandling: 'merge'
        };
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras));
    }

}
